module.exports = __webpack_public_path__ + "static/media/fisdom_hni_advisory_logo.8a36ddef.svg";